import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-SN0HZPJTR9";

const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

if (!isReactSnap) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

export const trackPageView = (path) => {
  if (isReactSnap) return;
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

